export default "__VITE_PUBLIC_ASSET__3887b849__"